module.exports = __webpack_public_path__ + "static/media/Becky Lannon Headshot.dc26572e.jpeg";